import { FaPython } from 'react-icons/fa';
import { SiLabview } from 'react-icons/si';
import { FiShield } from 'react-icons/fi';
import { CODESYSIcon } from './CODESYSIcon';

export const CATEGORY_ICONS = {
  'Python': FaPython,
  'LabVIEW': SiLabview,
  'Security': FiShield,
  'CODESYS': CODESYSIcon,
  // 将来的な新カテゴリーの追加も容易
};

export const getCategoryIcon = (categoryName) => {
  return CATEGORY_ICONS[categoryName] || FiShield; // デフォルトアイコン
}; 